import { Modal } from "react-bootstrap";
import "../styles/css/admin-style.css"

interface ConfirmationModalProps {
    show: boolean;
    toggle: () => void;
    onConfirm: () => void;
}

const NotifyAnywayModal: React.FC<ConfirmationModalProps> = ({ show, toggle, onConfirm}) => {

    return (
    <Modal show={show} onHide={toggle}>
        <Modal.Header>
            <h5 className="modal-title" id="exampleModalLabel">Are you sure?</h5>
            <button onClick={toggle} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </Modal.Header>
        <Modal.Body>
            <p>This customer has already been sent an estimate. Are you sure you want to send another estimate?</p>
        </Modal.Body>
        <Modal.Footer>
            <button onClick={onConfirm} className="btn btn-primary text-strong text-uppercase m-100">Send</button>
            <button onClick={toggle} className="btn btn-cancel text-strong text-uppercase m-100">Cancel</button>
        </Modal.Footer>
    </Modal>
    );
};
export default NotifyAnywayModal;


